// Week and date helpers for the saved mappings list, which draws the weeks a mapping was loaded
// on as a strip. Weeks are YYYYWW keys, as processor_history stores year and week.

// ISO 8601 week of a date, as a YYYYWW key (the week belongs to the year of its Thursday)
export function isoWeekKey(date) {
  const day = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  day.setUTCDate(day.getUTCDate() + 4 - (day.getUTCDay() || 7));
  const yearStart = new Date(Date.UTC(day.getUTCFullYear(), 0, 1));
  const week = Math.ceil(((day - yearStart) / 86400000 + 1) / 7);
  return day.getUTCFullYear() * 100 + week;
}

// The last `count` week keys up to the current week, oldest first
export function recentWeekKeys(count, today = new Date()) {
  const keys = [];
  for (let i = count - 1; i >= 0; i--) {
    keys.push(isoWeekKey(new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7 * i)));
  }
  return keys;
}

// "S43 2026"
export const weekLabel = (key) => `S${String(key % 100).padStart(2, '0')} ${Math.floor(key / 100)}`;

// "aujourd'hui", "hier", "il y a 5 j", "il y a 3 sem.", "il y a 4 mois", "il y a 2 ans"
export function timeAgo(isoDate, now = new Date()) {
  const days = Math.floor((now - new Date(isoDate)) / 86400000);
  if (days <= 0) return "aujourd'hui";
  if (days === 1) return 'hier';
  if (days < 14) return `il y a ${days} j`;
  if (days < 60) return `il y a ${Math.floor(days / 7)} sem.`;
  if (days < 365) return `il y a ${Math.floor(days / 30)} mois`;
  const years = Math.floor(days / 365);
  return `il y a ${years} an${years > 1 ? 's' : ''}`;
}
